const localeDE = require('moment/locale/de'); // eslint-disable-line
const localeCn = require('moment/locale/zh-cn'); // eslint-disable-line

export default function getLocale() {
  return {
    de: localeDE,
    cn: localeCn,
  };
}
